export interface IActionCenterDiabeticRecipientFollowUp {
    recipientId: number,
    recipientAlias: string,
    centerId: number
}